import { Inject, Injectable, NgModule } from '@angular/core';
import { NotificationService } from './notification.service';
import { Http, Headers, RequestMethod, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { SettingsStorageService } from './settings-storage.service';
import 'rxjs/add/operator/map';
/**
 * Service for managing JWT Auth Token from dotCMS Site/Host
 */
var JWTAuthService = (function () {
    function JWTAuthService(http, notificationService, settingsStorageService) {
        this.http = http;
        this.notificationService = notificationService;
        this.settingsStorageService = settingsStorageService;
    }
    /**
     * Will POST to the dotCMS to retrieve a dotCMS Auth Token
     * @param siteURL Site/Host of dotCMS
     * @param username
     * @param password
     * @returns {Observable<R>} String return for the token
     */
    JWTAuthService.prototype.getJWT = function (siteURL, username, password) {
        var _this = this;
        var data = {
            expirationDays: 30,
            password: password,
            user: username,
        };
        return this.doPostAuth(siteURL, data)
            .map(function (res) {
            if (res.status < 200 || res.status >= 300) {
                _this.handleError(res);
                throw new Error('This request has failed ' + res.status);
            }
            return _this.extractJWT(res);
        })
            .catch(function (error) { return _this.handleError(error); });
    };
    /**
     * Will login and save the Auth Token to local storage
     * @param siteURL
     * @param username
     * @param password
     * @returns {Observable<R>}
     */
    JWTAuthService.prototype.login = function (siteURL, username, password) {
        var _this = this;
        return this.getJWT(siteURL, username, password)
            .map(function (token) {
            _this.settingsStorageService.storeSettings(siteURL, token);
            return token;
        });
    };
    JWTAuthService.prototype.doPostAuth = function (siteUrl, data) {
        var opts = new RequestOptions();
        opts.method = RequestMethod.Post;
        opts.headers = new Headers({ 'Content-Type': 'application/json' });
        return this.http.post(siteUrl + '/api/v1/authentication/api-token', JSON.stringify(data), opts);
    };
    JWTAuthService.prototype.extractJWT = function (res) {
        var token;
        var obj = JSON.parse(res.text());
        var results = obj.entity.token;
        return results;
    };
    JWTAuthService.prototype.handleError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        if (errMsg) {
            console.error(errMsg);
            this.notificationService.displayErrorMessage('There was an error; please try again : ' + errMsg);
            return Observable.throw(errMsg);
        }
    };
    return JWTAuthService;
}());
export { JWTAuthService };
JWTAuthService.decorators = [
    { type: Injectable },
    { type: Inject, args: ['http',] },
    { type: Inject, args: ['notificationService',] },
    { type: Inject, args: ['settingsStorageService',] },
];
/** @nocollapse */
JWTAuthService.ctorParameters = function () { return [
    { type: Http, },
    { type: NotificationService, },
    { type: SettingsStorageService, },
]; };
var DotJWTAuthModule = (function () {
    function DotJWTAuthModule() {
    }
    return DotJWTAuthModule;
}());
export { DotJWTAuthModule };
DotJWTAuthModule.decorators = [
    { type: NgModule, args: [{
                providers: [JWTAuthService]
            },] },
];
/** @nocollapse */
DotJWTAuthModule.ctorParameters = function () { return []; };
//# sourceMappingURL=jwt-auth.service.js.map